import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { designSearchApi } from '../lib/api.js';
import { queryKeys } from '../lib/query-keys.js';
import type { DesignSearchParams } from '../types/design-search.js';

/**
 * デザイン成果物横断検索を TanStack Query 経由で実行する。
 *
 * キーワードが空でも新しい順のブラウズとして実行する（検索 TOP を検索後画面として初期表示する）。
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business デザイン成果物横断検索フック。キーワード有無に関わらず /design-search を叩き結果を返す（空はブラウズ）
 * @graph-connects /design-search [calls] デザイン成果物横断検索 API
 * @graph-connects designSearchApi.search [calls] 検索 API クライアント呼び出し
 * @graph-connects queryKeys [calls] TanStack Query キー生成
 */
export function useDesignSearch(params: DesignSearchParams) {
  return useQuery({
    queryKey: queryKeys.designSearch.search(params),
    queryFn: () => designSearchApi.search(params),
    placeholderData: keepPreviousData,
  });
}
